import React from 'react'
import {Card, Row, Col} from "react-bootstrap";

export default function AgreementPreview({cart}) {
    const agreementPartnership = cart?.agreement?.is_partnership
    return cart && (
        <Card>
            <Row className='px-3'>
                <Col sm={ 12 }>
                    <Card.Header className="py-5">
                        <div className="pt-1">
                            <h4 className="card-header-title">{ agreementPartnership ? 'Convenzione' : 'Codice convenzione' } </h4>
                        </div>
                    </Card.Header>
                    <Card.Body className='pb-4'>
                        <Row className='mb-1'>
                            <Col sm={ 3 } className="form-group my-auto">
                                <img src={ 'data:image/png;base64,' + cart?.agreement?.logo } alt='agreement_logo'
                                     style={ {maxHeight: '80px'} }/>
                            </Col>
                            <Col sm={ 9 } className="form-group my-auto">
                                {
                                    agreementPartnership ?
                                        <>
                                            <h5 className="pt-3"><span className={ 'text-uppercase' }>é</span> attiva
                                                una
                                                convenzione
                                                con { cart?.agreement?.name }.</h5>
                                        </> : <>
                                            <h5 className="pt-3">Con questo codice hai attivato una convenzione
                                                con { cart?.agreement?.name }.</h5>
                                            <h5 className="pt-3">{ cart?.agreement?.code }. </h5>
                                        </>
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                </Col>
            </Row>
        </Card>
    )
}


